import React, { useMemo, useState } from 'react';
import { TextField, IconButton, Chip, Grid, Autocomplete } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import propTypes from 'prop-types';

const administrationEmail = process.env.REACT_APP_ADMINISTRATION_EMAIL;

const EmailInput = ({ label, value, onAdd, suggestions }) => {
  const [inputValue, setInputValue] = useState('');
  const filteredOptions = useMemo(() => {
    return suggestions.filter((option) => !value.includes(option));
  }, [suggestions, value]);

  const handleInputChange = (event, newValue) => {
    setInputValue(newValue);
  };
  const handleAdd = () => {
    if (inputValue && /\S+@\S+\.\S+/.test(inputValue) && !value.includes(inputValue)) {
      onAdd(inputValue);
      setInputValue('');
    }
  };
  const isAdminEmail = (email) => email === administrationEmail;
  return (
    <>
      <Autocomplete
        fullWidth
        freeSolo
        options={filteredOptions}
        value={inputValue}
        onChange={(event, newValue) => handleInputChange(event, newValue)}
        onInputChange={(event, newValue) => setInputValue(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <IconButton color="primary" onClick={handleAdd}>
                  <AddIcon />
                </IconButton>
              ),
            }}
          />
        )}
      />

      <Grid container spacing={1} sx={{ mt: 1 }}>
        {value?.map((email, index) => (
          <Grid item key={index}>
            <Chip
              label={email}
              onDelete={() => onAdd(email, 'remove')}
              color={isAdminEmail(email) ? 'secondary' : 'primary'}
              sx={{ mr: 1, borderRadius: 1 }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

EmailInput.propTypes = {
  label: propTypes.string.isRequired,
  value: propTypes.array.isRequired,
  onAdd: propTypes.func.isRequired,
  suggestions: propTypes.array.isRequired,
};

export default EmailInput;
